import * as React from 'react'
/**
 * Creates the dropdown list for the CompanyLookup component
 *
 * @param {any} companyList
 * @param {any} selectNewCompany
 * @param {any} resetData
 */
const CompaniesList = (companyList, selectNewCompany, resetData) =>
    (companyList ?
        (
            <div className="address__list">
                {companyList.map((a, i) => (
                    <div
                        className="address__list__item"
                        onClick={() => selectNewCompany(a)}
                        key={i}
                    >
                        {a.name}
                    </div>
                ))}
            </div>
        )
        : (
            <div
                className="address__list"
                onClick={resetData}
            >
                <div
                    className="address__list__item"
                >
                    There are no matching companies...
                </div>

            </div>
        ))

export default CompaniesList



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Company/Components/CompaniesList.tsx